export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/cx.f21b79dd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};